import React from 'react'
import PropTypes from 'prop-types'
import Loader from '../Loader'
import {
  Button,
  StartAdornmentBox,
  EndAdornmentBox,
  Link
} from './style'

const MuiButton = props => {
  let object = {}

  const _delete = () => {
    const keys = Object.keys(props)
    keys.map(k => {
      if (!(k === 'to' || k === 'target' || k === 'href')) object[k] = props[k]
      return k
    })
  }

  if (props?.to || props?.href) {
    _delete()
  } else {
    object = props
  }

  const ButtonHolder = (prop) => {
    return (
      <Button {...prop} className='primary-button' disabled={(prop?.isSubmitting || prop?.disabled) && true} >
        {(prop?.isSubmitting) ? <Loader showLoader={true} size={15} style={{ marginRight: '10px' }} /> : (prop?.startAdornment) && <StartAdornmentBox >{prop?.startAdornment}</StartAdornmentBox>}
        {prop?.children}
        {prop?.endAdornment && <EndAdornmentBox>{prop?.endAdornment}</EndAdornmentBox>}
      </Button>
    )
  }

  return (
    <>
      {props?.to && <Link to={props.to}><ButtonHolder {...object} /></Link>}
      {props?.href && <a href={props.href} target={props?.target}><ButtonHolder {...object} /></a>}
      {!(props?.to || props?.href) && <ButtonHolder {...object} />}
    </>
  )
}

MuiButton.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  disabled: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  children: PropTypes.node || PropTypes.string,
  startAdornment: PropTypes.node || PropTypes.string,
  endAdornment: PropTypes.node || PropTypes.string
}

export default MuiButton
